export const dashboardKeys = {
  all: [{ module: 'dashboard' }] as const,
  infos: () => [{ ...dashboardKeys.all[0], scope: 'info' }] as const,
  info: (organizationId: string) => [{ ...dashboardKeys.infos()[0], organizationId }] as const,
  scriberInfos: () => [{ ...dashboardKeys.all[0], scope: 'scriberInfo' }] as const,
  scriberInfo: (organizationId: string) => [{ ...dashboardKeys.scriberInfos()[0], organizationId }] as const,
};
